/**
 * Info banner explaining blue-bordered AI-filled fields.
 *
 * Shown after dictation completes when AI-filled fields exist.
 * @module features/voice-report/components/DictationBanner/DictationBannerView
 */

import { Info } from "lucide-react-native";
import React, { memo } from "react";
import { Box } from "@/components/atoms/Box";

import { Stack } from "@/components/atoms/Stack";
import { Icon } from "@/components/atoms/Icon";
import { Text } from "@/components/atoms/Text";

/**
 * Banner explaining blue border convention for AI-filled fields.
 */
const DictationBannerView = () => (
  <Box className="rounded-sm bg-surface-info-subtle px-4 py-3">
    <Stack direction="horizontal" className="items-center gap-2">
      <Icon as={Info} size="sm" className="text-needs-semantic-info-600" />
      <Text variant="body" className="flex-1 text-status-info-strong">
        Fields with blue borders were filled by AI. Edit any field to take
        ownership.
      </Text>
    </Stack>
  </Box>
);

DictationBannerView.displayName = "DictationBannerView";

export default memo(DictationBannerView);
